//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFormCheck(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.5102 6.82001L10.2502 15.09L5.82016 10.66L4.41016 12.07L10.2502 17.91L19.9302 8.24001L18.5102 6.82001Z" fill="currentColor" /></svg>;
}
export default IconFormCheck;